import { Navigate, Outlet, createFileRoute, useLocation } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/settings")({
  component: SettingsLayout,
});

function SettingsLayout() {
  const path = useLocation({ select: (l) => l.pathname });

  if (path === "/settings") {
    return <Navigate to="/settings/general" replace />;
  }

  return <Outlet />;
}